import React from "react";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/modalSlice";
import Button from "../atoms/Button";

const SignInButton = () => {
  const dispatch = useDispatch();
  return (
    <Button
      variant="ghost"
      size="md"
      label="Sign in"
      onClick={(e) => {
        e.preventDefault();
        dispatch(openModal("SignIn"));
      }}
    />
  );
};
export default SignInButton;
